<div class="company-logo-container">
  @if(routeTo().length > 0) {
    <a [routerLink]="routeTo()">
      <img [src]="imageSource()" class="max-w-[180px]" />
    </a>
  } @else {
  <img [src]="imageSource()" class="max-w-[180px]" />
  }

  @if (shouldShowTitle) {
    <span class="company-logo-header">market assistant</span>
  }
</div>
